export default __webpack_public_path__ + "static/media/logo_white_words_800px.0c7af9aa.svg";